import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('e1Cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const updateCart = (item) => {
    if (item === null) {
      setCart([]);
      return;
    }
    
    setCart(prevCart => {
      const itemExists = prevCart.some(cartItem => cartItem.id === item.id);
      if (itemExists) {
        // Remove item do carrinho
        return prevCart.filter(cartItem => cartItem.id !== item.id);
      } else {
        // Adiciona item ao carrinho
        return [...prevCart, item];
      }
    });
  }

  useEffect(() => {
    if (cart) {
      localStorage.setItem('e1Cart', JSON.stringify(cart));
    }
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, updateCart }}>
      {children}
    </CartContext.Provider>
  );
};